import React, { type ReactNode } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import {
  TooltipPortal,
  type TooltipContentProps,
} from '@radix-ui/react-tooltip';
import { Text } from '../text/tw';
import { TooltipArrow, TooltipContent } from './TooltipPrimitives';
import type { TextTransform } from './Tooltip';

export interface TooltipContainerT
  extends Omit<TooltipContentProps, 'children'> {
  textTransform?: TextTransform | undefined;
  withPortal?: boolean;
  children: ReactNode | string | undefined;
}

export const animationClasses = [
  'animate-fade-in',
  'data-[state=closed]:data-[side=top]:motion-safe:animate-fade-out-top',
  'data-[state=closed]:data-[side=bottom]:motion-safe:animate-fade-out-bottom',
  'data-[state=closed]:data-[side=left]:motion-safe:animate-fade-out-left',
  'data-[state=closed]:data-[side=right]:motion-safe:animate-fade-out-right',
  'data-[side=top]:motion-safe:animate-fade-in-top',
  'data-[side=bottom]:motion-safe:animate-fade-in-bottom',
  'data-[side=left]:motion-safe:animate-fade-in-left',
  'data-[side=right]:motion-safe:animate-fade-in-right',
];

export const TooltipContainer = ({
  className,
  sideOffset,
  children,
  textTransform,
  withPortal = true,
  ...props
}: TooltipContainerT) => {
  const textTransformClass = textTransform ? textTransform : '';

  const content = (
    <TooltipContent
      sideOffset={sideOffset || 2}
      className={cn(
        'z-notification w-auto rounded-xl bg-high-contrast px-3 py-2 text-on-high-contrast',
        animationClasses,
        className,
      )}
      {...props}
    >
      <TooltipArrow />
      {typeof children === 'string' ? (
        <Text
          className={cn('text-87-5 text-on-high-contrast', textTransformClass)}
        >
          {children}
        </Text>
      ) : (
        children
      )}
    </TooltipContent>
  );

  return withPortal ? <TooltipPortal>{content}</TooltipPortal> : content;
};
